<template>
<div>
    <div class="top-background-bloc">
        <div class="pro-main-container-bloc pro-uska-link-container-bloc">
            <div class="flex-column container d-flex align-items-center justify-content-center">
                <div>
                    <img src="/images/logo-vertical-uska-couleur.png" class="uska-logo">
                </div>
                <div>
                    <div class="flex-column">
                        <div class="uska-link-text d-flex justify-content-center">Gratuit</div>
                        <hr class="border-4">
                        <div class="uska-link-text d-flex justify-content-center mb-2">Mettez à jour vos informations pour votre OT</div>
                        <div class="uska-link-text d-flex justify-content-center mb-2">Analysez votre présence en ligne</div>
                        <div class="uska-link-text d-flex justify-content-center mb-4">Retrouvez vos sollicitations</div>
                        <div class="d-flex justify-content-center">
                            <a
                              :href="uskaUrl" target="_blank"
                            >
                            <v-btn class="uska-link-button w-fit" >
                                    <span class="text-white">Créer mon compte gratuit</span>
                            </v-btn>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "ProUskaLink",
    data() {
        return {
            uskaUrl: null,
            token: null,
        }
    },
async created() {
    this.token = this.$route.params.token

    if(process.env.NODE_ENV === 'production') {
        this.uskaUrl = 'https://app.uska.fr/onboarding/freemium?utm_content=' + this.token +
          '&utm_source=hubo_freemium&utm_medium=contact'
    } else if(['development', 'qualif', 'dev'].includes(process.env.NODE_ENV)) {
        this.uskaUrl = 'https://qualif.app.uska.fr/onboarding/freemium?utm_content=' + this.token +
          '&utm_source=hubo_freemium&utm_medium=contact'
    }

}
}
</script>
